/**
 * Twin of functions/src/editChecks/protocolReferenceLabel.ts (web cannot import
 * from functions). Maps the legacy "Data Quality / GCDMP Coverage" reference,
 * which read like a protocol heading, to wording that says the check is not
 * stated in the protocol. Display only; stored checks are not rewritten.
 * functions/src/editChecks/protocolReferenceLabel.test.ts pins the wording.
 */
export const STANDARD_CHECK_REFERENCE = 'Standard data-quality check (not stated in the protocol)';

const LEGACY = new Set([
  'data quality / gcdmp coverage',
  'gcdmp coverage',
  'data quality',
  'general data quality',
]);

export function displayProtocolReference<T>(ref: T): T | string {
  if (typeof ref !== 'string') return ref;
  const key = ref.trim().replace(/\s+/g, ' ').replace(/\s*\/\s*/g, ' / ').toLowerCase();
  return LEGACY.has(key) ? STANDARD_CHECK_REFERENCE : ref;
}
